// Lazy accessor for the Supabase SDK client. Importing this module is cheap —
// the ~55 KiB @supabase/supabase-js chunk only loads on first `await getSupabase()`.
// Use this everywhere except `src/integrations/supabase/client.ts` itself.
import type { SupabaseClient } from "@supabase/supabase-js";

let p: Promise<SupabaseClient> | null = null;

export function getSupabase(): Promise<SupabaseClient> {
  if (!p) p = import("./client").then((m) => m.supabase);
  return p;
}
